// extracted by mini-css-extract-plugin
module.exports = {"last":"Vault_last__3IKvM"};